import { render, staticRenderFns } from "./MenuItemCollapsed.vue?vue&type=template&id=683bb741&scoped=true&"
import script from "./MenuItemCollapsed.vue?vue&type=script&lang=js&"
export * from "./MenuItemCollapsed.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCollapsed.vue?vue&type=style&index=0&id=683bb741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bb741",
  null
  
)

export default component.exports